// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CodeMirror{border:1px solid #ddd;max-width:1000px}", "",{"version":3,"sources":["webpack://./resources/assets/js/builder/components/layouts/BlackBox.vue"],"names":[],"mappings":"AACA,YACC,qBAAA,CACA,gBAAD","sourcesContent":["\n.CodeMirror {\n\tborder: 1px solid #ddd;\n\tmax-width: 1000px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
